// [hiperautomacao] Atomic CRM features this fork turns off.
// They depend on pieces the instance does not run (a file bucket, edge
// functions, an inbound email service) or that the template forbids
// (deleting a person's record instead of anonymizing it).
// Turning one on is a decision, not a toggle: see the fork README.
export const features = {
  /** Avatars, logos and note attachments need a storage bucket (personal data). */
  fileStorage: false,
  /** CSV/JSON import writes in bulk, bypassing the seller's review. */
  dataImport: false,
  /** Merging deletes a contact; the template merges with fundida_em instead. */
  contactMerge: false,
  /** Sellers are registered in the instance (crm_interno.cadastrar_vendedor). */
  userAdmin: false,
  /** Password changes go through the login page ("forgot password"). */
  passwordChange: false,
  /** Inbound email and MCP server need edge functions. */
  inboundEmail: false,
  mcpServer: false,
} as const;
